import { z } from 'zod';

const nullableDescription = z.string().trim().max(500).optional().nullable();

export const ReportConfidentialityClassSchema = z.object({
    id: z.string().optional(),
    name: z.string().trim().min(1).max(120),
    code: z.string().trim().min(1).max(40).regex(/^[A-Za-z0-9][A-Za-z0-9._-]*$/),
    level: z.number().int().min(0).max(100),
    color: z.string().regex(/^#[0-9a-fA-F]{6}$/).default('#1f4e78'),
    watermark: z.object({
        enabled: z.boolean(),
        text: z.string().trim().max(160).optional().nullable(),
    }).strict().superRefine((value, ctx) => {
        if (value.enabled && !value.text?.trim()) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                path: ['text'],
                message: 'Watermark text is required when the watermark is enabled',
            });
        }
    }).optional(),
    description: nullableDescription,
    status: z.enum(['active', 'inactive']).default('active'),
    isDefault: z.boolean().default(false),
    createdAt: z.date().optional(),
    updatedAt: z.date().optional(),
}).strict();

export const CreateReportConfidentialityClassSchema = ReportConfidentialityClassSchema.omit({
    id: true,
    createdAt: true,
    updatedAt: true,
});

export const UpdateReportConfidentialityClassSchema = CreateReportConfidentialityClassSchema
    .partial()
    .refine((value) => Object.keys(value).length > 0, {
        message: 'At least one confidentiality class field must be updated',
    });
